import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AddComponent } from './add/add.component';
import { AppointmentComponent } from './appointment.component';
import { AppointmentsDoctorComponent } from './doctor/doctor.component';
import { SearchComponent } from './search/search.component';
import { AppointmentSpecialtiesComponent } from './specialties/specialties.component';
import { AnotherServiceComponent } from './another-service/another-service.component';
import { AppointmentsGuard } from './appointments.guard';

const routes: Routes = [
  {
    path: '',
    component: AppointmentComponent,
    children: [
      {
        path: 'search',
        component: SearchComponent,
        canActivate : [AppointmentsGuard],
      },
      {
        path: 'addappointment/:specialtyId/:doctorId',
        component: AddComponent,
      },
      {
        path: 'another-service',
        component: AnotherServiceComponent,
      },
      {path: 'specialties', component: AppointmentSpecialtiesComponent},
      {path: 'doctors/:specialtyId', component: AppointmentsDoctorComponent},
      { path: '', redirectTo: 'search', pathMatch: 'full' },
      { path: '**', redirectTo: 'search', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AppointmentsRoutingModule {}
